<template>
  <div>
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-12">
          <h6 class="h2 text-white d-inline-block mb-0">Crear Pedido</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6">
      <div class="row justify-content-center">
        <pre-select-form
          v-show="!canCreate"
          :subtitle="subtitle"
          :empty-producer-cuit-filter="false"
          @selected="onSelect"
        />

        <order-form
          v-if="canCreate"
          :campaign="campaign"
          :producer="producer"
          :projection="projection"
          :order-id="orderId"
          :order="order"
          @back="backToPreSelect"
          @confirm="confirmOrder"
          @save="saveOrder"
        />
      </div>
    </div>
  </div>
</template>

<script>
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import OrderForm from './Forms/OrderForm';
import PreSelectForm from '../../components/ModelSelects/PreSelectProducerCampaign';
import swal from 'sweetalert2';

export default {
  name: 'OrdersCreate',
  components: {
    RouteBreadCrumb,
    OrderForm,
    PreSelectForm,
  },

  data() {
    return {
      campaign: null,
      producer: null,
      order: undefined,
      orderId: 0,
      subtitle: 'Elija la campaña y productor, y pulse en SELECCIONAR para realizar el pedido',
      projection: null,
      orderCreated: false,
    };
  },

  computed: {
    canCreate() {
      return this.campaign && this.producer;
    },
  },

  created() {
    const campaign = this.$route.query.campaign;
    const producer = this.$route.query.producer;
    if (campaign && producer) {
      this.onSelect(producer, campaign);
    }
    if (this.$route.query.projection) {
      this.fetchProjection(this.$route.query.projection);
    }
  },

  methods: {
    backToPreSelect() {
      this.campaign = null;
      this.producer = null;
    },

    onSelect(producer, campaign) {
      this.fetchCampaign(campaign);
      this.fetchProducer(producer);
    },

    fetchProjection(id) {
      this.$services
        .resource('projections')
        .show(id)
        .then((res) => res.data.data)
        .then((projection) => {
          this.projection = projection;
        });
    },

    fetchProducer(id) {
      this.$services
        .resource('producers')
        .show(id, { include: ['distributor.seller'] })
        .then((res) => res.data.data)
        .then((producer) => (this.producer = producer));
    },

    fetchCampaign(id) {
      this.$services
        .resource('campaigns')
        .show(id, { include: ['crops', 'articles'] })
        .then((res) => res.data.data)
        .then((campaign) => (this.campaign = campaign));
    },

    saveOrder(order) {
      if (this.orderCreated) {
        this.updateOrder(order);
      } else {
        this.createOrder(order);
      }
    },

    createOrder(order) {
      order.producerId = this.producer.id;
      order.campaignId = this.campaign.id;
      if (this.projection) {
        order.projectionId = this.projection.id;
      }
      this.$services
        .resource('orders')
        .create(order)
        .then((res) => res.data.data)
        .then((model) => {
          order.state = model.state;
          order.code = model.code;

          this.orderId = model.id;
          this.order = model;
          this.orderCreated = true;
        });
    },

    updateOrder(order) {
      this.$services
        .resource('orders')
        .update(this.orderId, order)
        .then((res) => res.data.data)
        .then((order) => {
          this.order = order;
        })
        .catch(() => {
          this.order = null;
          this.isDataLoaded = false;
          this.fetchOrder();
        });
    },

    confirmOrder() {
      // redirigir al resumen de pedido
      this.$services
        .resource('orders')
        .confirm(this.orderId)
        .then(() => {
          const canShowOrders = this.$can('show', 'orders');
          swal({
            title: 'Listo!',
            text: 'El pedido fue confirmado.',
            type: 'success',
            showCancelButton: true,
            buttonsStyling: false,
            confirmButtonText: canShowOrders ? 'Ver Pedido' : 'Listado Pedidos',
            cancelButtonText: 'Nuevo Pedido',
            confirmButtonClass: 'btn btn-secondary',
            cancelButtonClass: 'btn btn-success',
          }).then((choice) => {
            if (choice.value) {
              if (canShowOrders) {
                this.$router.push({ name: 'OrderShow', params: { id: this.orderId } });
              } else {
                this.$router.push({ name: 'OrdersList' });
              }
            } else {
              this.reset();
            }
          });
        })
        .catch(() => {
          // this.serverErrors = errors
        });
    },

    reset() {
      this.orderId = 0;
      this.campaign = null;
      this.producer = null;
    },
  },
};
</script>
